import React from 'react';
import WrappedView from 'system/components/WrappedView';
import { paths } from 'system/routes';
import urls from 'system/urls';
import { loadableLib } from 'system/loadableUtils';
import { UserContext } from 'system/contexts/user';
import DummyNavigation from 'system/components/DummyNavigation';
import * as Routes from './routes';

const AsyncPage = loadableLib(({ viewUrl, fetchFromSystem }) => (
  !fetchFromSystem
    ? import(`app/unregistered/${viewUrl}`)
    : import(`system/${viewUrl}`)
), {
  cacheKey: ({ viewUrl }) => viewUrl
});

// eslint-disable-next-line import/prefer-default-export
export const getPages = () => ({
  [paths.documentUnregistered()]: {
    component: (props) => (
      <UserContext.Consumer>
        {(user) => (
          <>
            <Routes.Document
              currentUser={user}
              {...props}
            />
          </>
        )}
      </UserContext.Consumer>
    )
  },
  [paths.whyRegister]: {
    component: (props) => (
      <>
        <DummyNavigation />
        <WrappedView
          AsyncPage={AsyncPage}
          fetchFromSystem
          viewURL="views/iframe"
          title="whyRegisterForPTXConnect"
          className="unregistered-content"
          // can't use query approach due to encodeURIComponent
          frameUrl={`${urls.whyRegister}?returnUrl=${window.location.href}`}
          showNav
          useStyles
          backButton
          {...props}
        />
      </>
    )
  },

  notFound: {
    component: (props) => (
      <>
        <DummyNavigation />
        <WrappedView
          AsyncPage={AsyncPage}
          fetchFromSystem
          viewURL="views/errorPage"
          title="notFound"
          className="unregistered-content"
          notFound
          showNav
          useStyles
          {...props}
        />
      </>
    )
  },
  [paths.webformsError]: {
    component: (props) => (
      <>
        <Routes.WebformsError
          {...props}
        />
      </>
    )
  },
  [paths.revokedNotice]: {
    component: (props) => (
      <>
        <Routes.RevokedNotice
          {...props}
        />
      </>
    )
  }
});
